import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-counter',
  template: `<ng-container>{{ count | localNumber }}</ng-container>`,
})
export class CounterComponent implements OnInit, OnChanges {
  @Input() target: number;
  @Input() speed = 1; // this.speed < 1 makes counter faster
  count = 0;
  updateCount = () => {
    const inc = 10;
    const percent = this.count / this.target;

    if (this.count < this.target) {
      if (this.count + inc > this.target) {
        this.count = this.target;
      } else {
        this.count += inc;
        setTimeout(this.updateCount, 10 * percent * this.speed);
      }
    } else if (this.count > this.target) {
      if (this.count - inc < this.target) {
        this.count = this.target;
      } else {
        this.count -= inc;
        setTimeout(this.updateCount, 10 * percent * this.speed);
      }
    }
  };
  ngOnInit() {
    this.updateCount();
  }

  ngOnChanges() {
    this.updateCount();
  }
}
